import { forwardRef, type Ref, type SVGProps } from "react";
const IconVolumeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M23.055 11.594C21.917 10.494 20.653 10 20 10a1 1 0 1 1 0-2c1.347 0 3.083.84 4.445 2.156C25.845 11.51 27 13.506 27 16c0 2.645-1.142 4.65-2.568 5.981C23.044 23.276 21.312 24 20 24a1 1 0 1 1 0-2c.689 0 1.956-.443 3.068-1.481C24.142 19.516 25 18.021 25 16c0-1.84-.846-3.344-1.945-4.406"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M19.76 13.971h-.003a1 1 0 0 1 .485-1.941c.634.158 1.306.695 1.794 1.314C22.552 14 23 14.92 23 16s-.448 2-.964 2.656c-.488.62-1.16 1.156-1.794 1.314a1 1 0 0 1-.485-1.94l.002-.001c.016-.007.099-.041.235-.143a2.6 2.6 0 0 0 .47-.467c.317-.403.536-.9.536-1.419 0-.52-.219-1.016-.536-1.419a2.6 2.6 0 0 0-.47-.467c-.136-.102-.219-.136-.235-.143m-3.335-6.877A1 1 0 0 1 17 8v16a1 1 0 0 1-1.64.768L9.638 20H6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h3.638l5.722-4.768a1 1 0 0 1 1.064-.138"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconVolumeFilledSVG);
ForwardRef.displayName = "IconVolumeFilled";
export { ForwardRef as IconVolumeFilled };
